import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { has_reference_objects } from '../../non_graphical_ui_actions';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { img } from '@phi/components';
import attach_stl_svg from '../../../assets/img/SVG_icons/Top/reference_operation/start_attaching_to_stl.svg';
import { start_attaching_to_stl, stop_attaching_to_stl } from '@frontend/import_3d_scan_data';
import AttachToSTLTooltip from './AttachToSTLTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const AttachToSTLIcon = attach_stl_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Attach to reference STL';
        },

        disabled() {
            return !this.state.loaded
                || this.state.is_demo
                || !(
                    (
                        this.state.showing_reference_stl
                        && this.total_selected_objects > 1
                        && has_reference_objects()
                    )
                    || this.state.attaching_to_stl
                );
        },

        total_selected_objects() {
            return this.state.selected_edges_count
                + this.state.selected_faces_count
                + this.state.selected_vertices_count;
        },
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            //else if (this.subscriptions.state.subscription_status.value === 'starter')
            //    this.subscriptions.show_pro_feature_modal();
            else if (this.state.attaching_to_stl)
                stop_attaching_to_stl();
            else
                start_attaching_to_stl();
        },
    },

    render() {
        return h(BarButton, {
            id: 'start-attaching-to-stl-button',
            tippy: 'left',
            active: this.state.attaching_to_stl,
            disabled: this.disabled,
            onClick: this.onClick,
            help: 'attach_to_stl',
            //pro_indicator: this.subscriptions.state.subscription_status.value === 'starter',
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(attach_stl_svg, this.alt),
            tooltip: AttachToSTLTooltip,
        });
    },
});
